import { put, takeEvery, call } from 'redux-saga/effects';
import get from '../getApiCaller';

const API_DATA = (payload) => {
  return get(`places/states/${payload}`, 'GET', true).then((response) => {
    return response;
  });
};

export const GET_STATES_SAGA = function* perform_loginAction() {
  yield takeEvery('GET_STATES', function* (action) {
    yield put({ type: 'GET_STATES_STARTED' });
    try {
      const DATA = yield call(API_DATA.bind(this, action.payload));
      yield put({
        type: 'GET_STATES_SUCCESS',
        payload: DATA,
      });
    } catch (error) {
      yield put({
        type: 'GET_STATES_FAILED',
        payload: error,
      });
    }
  });
};
